/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ROWS_PER_PAGE_LABEL = 'Rows per page:';
export const DELETE_TITLE = "Are you sure you want to delete the mapping between {name} and {realmName}?";
export const DIALOUGE_CONTENT = "Delete Role Mapping?";
export const DIALOUGE_OK = "Delete";
export const DIALOUGE_CANCEL = "Cancel";
